import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:5545642f-29b5-4386-8dd1-a7789c875f17",
    aws_user_pools_id: "eu-west-1_X8Ddpxqu4",
    aws_user_pools_web_client_id: "29g4jm6palt7flt5gfr20hn7u7",
    Auth: {
      identityPoolId: "eu-west-1:5545642f-29b5-4386-8dd1-a7789c875f17",
      region: "eu-west-1",
      userPoolId: "eu-west-1_X8Ddpxqu4",
      userPoolWebClientId: "29g4jm6palt7flt5gfr20hn7u7",
    },
    oauth: {
      domain: "whs-safer-prod-mena.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://prod.mena.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.mena.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve prod to "test".
  const stage = "prod".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
